module.exports = __webpack_public_path__ + "static/img/1.c81fed8.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/10/eng/1.png
// module id = Qgmn
// module chunks = 0